<template>
  <div v-if="isDisplay" class="modal cursor-pointer" @click="close">
    <div class="modal-content cursor-auto" @click.stop>
      <div class="flex lg:flex-col flex-row md:w-600 lg:w-800">
        <div class="grid md:grid-cols-2">
          <div>
            <img class="w-full h-326 object-cover" :src="artist.latestArtwork.images.fullImage.original" :alt="altBackground">
          </div>
          <div class="w-full h-full flex flex-col justify-center p-20">
            <div class="w-full md:flex justify-end hidden">
              <button class="close-btn focus:outline-none float-right" @click="close">
                <i class="far fa-times"></i>
              </button>
            </div>
            <div class="font-black pb-24 lg:pb-32 text-18 md:text-24">Follow {{ artist.name.trim() }}.</div>

            <div class="mb-20">
              Be the first to be exclusively notified of new works by {{ artist.name.trim() }}.
            </div>

            <button @click="checkAuthentication"
              class="btn btn-primary-black w-full text-base lg:text-16 focus:outline-none mb-14 lg:mb-20">
              Follow now & Subscribe
            </button>

            <button class="btn border border-black hover:bg-black hover:text-white w-full text-base lg:text-16 focus:outline-none transition-all duration-300 ease-in-out" @click="close">
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheArtistSubscriptionPanel",

  data() {
    return {
      api: '/web/api/subscribe/artist',
      isDisplay: false,
      artist: {},
      background: null,
      altBackground: null,
      formData: {
        artistSlug: '',
      }
    }
  },

  methods: {
    subscribe() {
      axios.post(this.api, this.formData)
        .then(({ data }) => {
          this.$artistSubscription.$emit('subscribe', this.formData.artistSlug)
          this.close()
          this.$root.$refs.notification.notify({
            title: data.title,
            message: data.message,
            type: 'warning-dark',
          })
        })
    },

    checkAuthentication() {
      axios.get('/web/api/subscribe/show')
        .then((success) => {
          this.subscribe()
        })
        .catch((error) => {
          if (error.response.status === 403) {
            let parameter = { follow_artist: this.formData.artistSlug }
            let header = `To follow ${this.artist.name}, sign in to drybrush Gallery`
            this.$root.$refs.signInModal.toggle(parameter, header)
            this.close()
          }
        })
    },

    open(artist, background, altBackground) {
      this.isDisplay = true
      this.artist = artist
      this.background = background
      this.altBackground = altBackground
      this.formData.artistSlug = artist.slug
      document.body.style.overflowY = 'hidden'
    },

    close() {
      this.isDisplay = false
      this.artist = {}
      this.background = null
      this.altBackground = null
      this.formData.artistSlug = ''
      this.formData.email = ''
      document.body.style.overflowY = ''
    },
  }
}
</script>

<style scoped>
.input-icon {
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 16px;
  margin-left: 16px;
  color: #a0aec0
}
</style>
